import './dashboard.scss'

import { MovementFeaturedList, TaskFeaturedList } from '@skinsoft/entity-ui'
import { ReactiveVue } from '@skinsoft/reactive-vue'
import { Component } from 'vue-property-decorator'
import { Modal } from 'bootstrap-vue'

import { Routes } from '../router'

@Component({
    components: {
        sMovementFeaturedList: MovementFeaturedList,
        sTaskFeaturedList: TaskFeaturedList,
    },
    template: require('./dashboard.html'),
})
export class Dashboard extends ReactiveVue {
    public Routes = Routes

    public $refs: {
        modal: Modal
    }

    public mounted() {
        this.$refs.modal.show()
    }

    public goBack() {
        this.$router.push(Routes.MOVEMENTS)
    }
}
